module.exports = __webpack_public_path__ + "static/img/BR@2x.0c4a09e7.jpg";